import {
  InspectorPortalInspectionType,
  ViewingsDispatchLifecycleStatus,
} from "@/schemas";
import { IntlShape } from "react-intl";

export function getLifecycleStatusLabel(
  intl: IntlShape,
  status: ViewingsDispatchLifecycleStatus,
) {
  return intl.formatMessage({ id: `viewings.status.${status}` });
}

export function getInspectionTypeLabel(
  intl: IntlShape,
  inspectionType: InspectorPortalInspectionType,
) {
  return intl.formatMessage({
    id: `viewings.inspectionType.${inspectionType}`,
  });
}
